/*
 * Move sold-out products to the end of every product grid/collection.
 * This theme marks unavailable product cards with:
 *   hdt-card-product hdt-pr-sold_out
 *
 * Important: this version does NOT append/remove cards from the DOM.
 * It uses CSS order, which lets the grid reflow without empty spaces or flicker.
 */
(function () {
  'use strict';

  var GRID_SELECTORS = [
    '.hdt-collection-products',
    'hdt-reval-items.hdt-collection-products',
    '.hdt-row-grid',
    '.hdt-slider__wrapper'
  ].join(',');

  var CARD_SELECTORS = [
    'hdt-card-product',
    '[class*="hdt-pr-style"]',
    '[class*="hdt-slider__slide"]'
  ].join(',');

  var timer = null;

  function isProductCard(element) {
    return element && element.nodeType === 1 && element.matches(CARD_SELECTORS);
  }

  function sortGrid(grid) {
    if (!grid || grid.nodeType !== 1) return;

    // Only direct children are considered, so nested recommendation grids
    // cannot be mixed into the current collection grid.
    var cards = Array.prototype.filter.call(grid.children, isProductCard);
    if (cards.length < 2) return;

    var hasSoldOut = cards.some(function (card) {
      return card.classList.contains('hdt-pr-sold_out');
    });

    if (!hasSoldOut) return;

    // CSS order sorts visually but keeps the DOM and grid dimensions intact.
    // Equal order values preserve the original order within each group.
    cards.forEach(function (card) {
      card.style.order = card.classList.contains('hdt-pr-sold_out') ? '2' : '1';
    });
  }

  function sortAllGrids() {
    document.querySelectorAll(GRID_SELECTORS).forEach(sortGrid);
  }

  function scheduleSort() {
    window.clearTimeout(timer);
    timer = window.setTimeout(sortAllGrids, 120);
  }

  function start() {
    sortAllGrids();

    // The theme replaces product results when filters, sorting, pagination,
    // or infinite loading are used. Observe only child changes; changing
    // inline order does not trigger this observer.
    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(scheduleSort);
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
